import { GridType } from '@ui-system/interfaces-grid';
import { pleaseImplement } from '@ui-system/utils';

// MAYBE USE https://sealninja.github.io/react-grid-system/;
// @ts-ignore
const Grid = pleaseImplement<GridType>('Grid');

export default Grid;
